import React from 'react'
import { CERT_IMAGE, BW_CERT_IMAGE } from '../../../../services/badging/constants';
import { GetBrandedTutorName } from '../../../../services/BrandingService';

export default function BadgeCertificate(props) {
  const {
      awarder,
      recipient,
      dateString,
      description,
      rewardLevelId,
      width=1100,
      height=850,
      baseFontSize=40,
      isColorPrint=true,
  } = props;

  let certImageSrc = CERT_IMAGE[rewardLevelId];
  if (!isColorPrint) certImageSrc = BW_CERT_IMAGE[rewardLevelId];

  const wrapperStyle = {...styles.wrapper};
  wrapperStyle.width = width;
  wrapperStyle.height = height;
  wrapperStyle.fontSize = baseFontSize;

  const titleStyle = {...styles.title};
  titleStyle.color = titleColors[rewardLevelId];
  if (!isColorPrint) titleStyle.color = 'black';

  const dividerStyle = {...styles.divider}
  if (!isColorPrint) dividerStyle.background = 'black';

  return (
    <div style={wrapperStyle}>
      <img src={certImageSrc} style={styles.certImage} />
      <div style={titleStyle}>YOUR {GetBrandedTutorName()} AWARD</div>
      <div style={styles.recipient}>{recipient}</div>
      <div style={dividerStyle} />
      <div style={styles.awarder}>{GetBrandedTutorName()} Honors You For:</div>
      <div style={styles.description}>{description}</div>
      <div style={styles.date}>Achieved: {dateString}</div>
    </div>
  )
}

const titleColors = {
  PAL: '#2DD9D9',
  BUDDY: '#407CFF',
  RANGER: '#05BEE8',
  TITAN: '#BF2817',
  GURU: '#CC5ACC',
  WIZARD: '#8CD43E',
}

// styles are inline because certs are printed in a tab without access to stylesheets
// see CertificatePrintWrapper's printCertificates function

const styles = {
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    pageBreakAfter: 'always',
    position: 'relative',
    fontFamily: 'Quicksand',
    fontWeight: '600',
  },
  certImage: {
    position: 'absolute',
    height: '100%',
    width: '100%',
  },
  title: {
    position: 'absolute',
    top: '8%',
    fontSize: '120%',
    fontWeight: 700,
    letterSpacing: 1,
  },
  recipient: {
    position: 'absolute',
    top: '18%',
    fontSize: '115%',
    fontWeight: '700',
  },
  divider: {
    position: 'absolute',
    top: '27%',
    width: '50%',
    height: '0.6%',
    background: '#734699',
  },
  awarder: {
    position: 'absolute',
    top: '34%',
  },
  description: {
    position: 'absolute',
    top: '50%',
    fontWeight: '500',
    maxWidth: '40%',
  },
  date: {
    position: 'absolute',
    bottom: '8%',
    fontWeight: '500',
    fontSize: '75%',
  },
}